import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

interface Props {
  children: React.ReactElement[] | React.ReactElement | string
  show: boolean
}

const useStyles = makeStyles(() => ({
  container: {
    '& span, p, h1, h2, h3, h4, h5, h6, td, a, label, input': {
      color: 'transparent !important' as  any,
      backgroundColor: '#CCCCCC',
      background: 'linear-gradient(90deg, rgba(236,236,236,1) 20%, rgba(161,161,161,1) 50%, rgba(236,236,236,1) 80%)',
      backgroundAttachment: 'fixed',

      '-webkit-text-fill-color': 'transparent',
      '-webkit-background-clip': 'content-box',
      'animation-name': 'moving-gradient',
      'animation-duration': '2s',
      'animation-iteration-count': 'infinite',
      'animation-fill-mode': 'forwards',
      'animation-timing-function': 'linear'
    }
  }
}));

const LoaderBox = (props: Props) => {
  const { children, show } = props;
  const classes = useStyles();

  return <div className={show?classes.container:''}>{children}</div>;
};

export default LoaderBox;
